export default __webpack_public_path__ + "static/bg-22ccacd8a19753a44f1e61c63ad290ac.mp4";